/**
 * These are the Direct Connect permissions.
 */
export const directConnectPermissions = {
  DeviceDetails: {
    Read: "directConnectDeviceDetailsCanRead"
  }
};
